import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Form,
  FormGroup,
  FormField,
  Dropdown,
  Checkbox
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardRehabWorkListUX = (props: any) => {
    return(
      <div
        style={{padding: "0.5rem 1rem"}}>
        <Form
          className="size small"
          id="CardRehabWorklistUX-Form-35">
          <FormGroup
            id="CardRehabWorklistUX-FormGroup-36">
            <FormField
              id="CardRehabWorklistUX-FormField-37"
              width={3}>
              <label
                id="CardRehabWorklistUX-label-44">
                {props.languageUX === "en" ? "Patient" : "ผู้ป่วย"}
              </label>
              <div
                id="CardRehabWorklistUX-div-51"
                style={{width: "100%"}}>
                {props.patientSearchBox}
              </div>
            </FormField>
            <FormField
              id="CardRehabWorklistUX-FormField-38"
              width={2}>
              <label
                id="CardRehabWorklistUX-label-45">
                {props.languageUX === "en" ? "Date" : "วันที่"}
              </label>
              <div
                id="CardRehabWorklistUX-div-52"
                style={{width: "100%"}}>

                <DateTextBox
                  id="CardRehabWorklistUX-DateTextBox-57"
                  onChange={(value: any)=>props.onChangeFilter?.(null,{name: "order_time", value})}
                  value={props.filter?.order_time}>
                </DateTextBox>
              </div>
            </FormField>
            <FormField
              id="CardRehabWorklistUX-FormField-39"
              width={2}>
              <label
                id="CardRehabWorklistUX-label-46">
                {props.languageUX === "en" ? "Encounter type" : "หมายเลขรับบริการ"}
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardRehabWorklistUX-Dropdown-53"
                name="encounter_type"
                onChange={props.onChangeFilter}
                options={props.encounterTypeOptions}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.filter?.encounter_type ?? ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardRehabWorklistUX-FormField-40"
              width={3}>
              <label
                id="CardRehabWorklistUX-label-47">
                {props.languageUX === "en" ? "Patient Division" : "แผนกของผู้ป่วย"}
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardRehabWorklistUX-Dropdown-54"
                name="encounter_division"
                onChange={props.onChangeFilter}
                options={props.divisionOptions}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.filter?.encounter_division?? ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardRehabWorklistUX-FormField-41"
              width={3}>
              <label
                id="CardRehabWorklistUX-label-48">
                {props.languageUX === "en" ? "Order to department" : "ส่งไปยังแผนก"}
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardRehabWorklistUX-Dropdown-55"
                name="to_department_for_physiotherapist"
                onChange={props.onChangeFilter}
                options={props.divisionOptions}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.filter?.to_department_for_physiotherapist ?? ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardRehabWorkListUX-FormField-59"
              width={3}>
              <label
                id="CardRehabWorkListUX-label-60">
                {props.languageUX === "en" ? "Physical Therapist" : "นักกายภาพบำบัด"}
              </label>
              <div
                id="CardRehabWorkListUX-div-61"
                style={{width: "100%"}}>
                {props.physiotherapistSearchBox}
              </div>
            </FormField>
            <FormField
              id="CardRehabWorklistUX-FormField-42">
              <label
                id="CardRehabWorklistUX-label-49">
                {"\u00A0"}
              </label>
              <div
                id="CardRehabWorklistUX-div-56">
                {props.buttonSearch}
              </div>
            </FormField>
            <FormField
              id="CardRehabWorklistUX-FormField-43"
              style={{display: "flex",alignItems: "flex-end", justifyContent: "flex-end"}}
              width={4}>
              <label
                id="CardRehabWorklistUX-label-50">
                {"\u00A0"}
              </label>
              <Checkbox
                checked={props.filter?.include_complete ?? false}
                id="CardRehabWorklistUX-Checkbox-58"
                label={props.languageUX === "en" ? "Included Complete" : "แสดงรายการที่สมบูรณ์"}
                name="include_complete"
                onChange={props.onChangeFilter}>
              </Checkbox>
            </FormField>
          </FormGroup>
        </Form>
        <div>

          <Table
            data={props.items}
            getTdProps={props.getTdProps}
            getTrProps={props.getTrProps}
            headers={props.languageUX === "en" ? "Encounter type,Encounter date,HN (Encounter),Patient,Patient Division,Encounter Status,Doctor,Order to department,Physical Therapist," : "ประเภทรับบริการ,วันที่รับบริการ,HN (EN),ผู้ป่วย, แผนกของผู้ป่วย, สถานะ,แพทย์,ส่งไปยังแผนก,นักกายภาพบำบัด"}
            keys="en_type,date,hnEncounter,patient,en_division,en_status,doctor_full_name,to_department_for_physiotherapist_name,physiotherapist,action"
            showPagination={false}
            style={{height: "calc(100vh - 14rem)"}}
            widths="^90,^90,^90,^150,^150,^125,^150,^150,^150,100">
          </Table>
        </div>
      </div>
    )
}


export default CardRehabWorkListUX

export const screenPropsDefault = {"cannotPay":false,"cashAmountText":"14","citizenID":"31020000552","language":"TH","oweText":123,"patientNameAndHN":"HN: xxxxx นายทดสอบ","sumAmount":{"price":100,"reimbursable":42}}

/* Date Time : Fri Aug 22 2025 10:12:29 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0.5rem 1rem\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 33,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 34,
      "name": "Table",
      "parent": 33,
      "props": {
        "data": {
          "type": "code",
          "value": "props.items"
        },
        "getTdProps": {
          "type": "code",
          "value": "props.getTdProps"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.getTrProps"
        },
        "headers": {
          "type": "value",
          "value": "ประเภทรับบริการ,วันที่รับบริการ,HN (EN),ผู้ป่วย, แผนกของผู้ป่วย, สถานะ,แพทย์,ส่งไปยังแผนก,นักกายภาพบำบัด",
          "valueEN": "Encounter type,Encounter date,HN (Encounter),Patient,Patient Division,Encounter Status,Doctor,Order to department,Physical Therapist,"
        },
        "id": {
          "type": "value",
          "value": ""
        },
        "keys": {
          "type": "value",
          "value": "en_type,date,hnEncounter,patient,en_division,en_status,doctor_full_name,to_department_for_physiotherapist_name,physiotherapist,action"
        },
        "name": {
          "type": "value",
          "value": ""
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"calc(100vh - 14rem)\"}"
        },
        "widths": {
          "type": "value",
          "value": "^90,^90,^90,^150,^150,^125,^150,^150,^150,100"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "Form",
      "parent": 0,
      "props": {
        "className": {
          "type": "value",
          "value": "size small"
        },
        "id": {
          "type": "value",
          "value": "CardRehabWorklistUX-Form-35"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 36,
      "name": "FormGroup",
      "parent": 35,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabWorklistUX-FormGroup-36"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "FormField",
      "parent": 36,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabWorklistUX-FormField-37"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 38,
      "name": "FormField",
      "parent": 36,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabWorklistUX-FormField-38"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "FormField",
      "parent": 36,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabWorklistUX-FormField-39"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 40,
      "name": "FormField",
      "parent": 36,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabWorklistUX-FormField-40"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "FormField",
      "parent": 36,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabWorklistUX-FormField-41"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 42,
      "name": "FormField",
      "parent": 36,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabWorklistUX-FormField-42"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "FormField",
      "parent": 36,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabWorklistUX-FormField-43"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\",alignItems: \"flex-end\", justifyContent: \"flex-end\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "label",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ป่วย",
          "valueEN": "Patient"
        },
        "id": {
          "type": "value",
          "value": "CardRehabWorklistUX-label-44"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "label",
      "parent": 38,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่",
          "valueEN": "Date"
        },
        "id": {
          "type": "value",
          "value": "CardRehabWorklistUX-label-45"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "label",
      "parent": 39,
      "props": {
        "children": {
          "type": "value",
          "value": "หมายเลขรับบริการ",
          "valueEN": "Encounter type"
        },
        "id": {
          "type": "value",
          "value": "CardRehabWorklistUX-label-46"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "label",
      "parent": 40,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนกของผู้ป่วย",
          "valueEN": "Patient Division"
        },
        "id": {
          "type": "value",
          "value": "CardRehabWorklistUX-label-47"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "label",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": "ส่งไปยังแผนก",
          "valueEN": "Order to department"
        },
        "id": {
          "type": "value",
          "value": "CardRehabWorklistUX-label-48"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "label",
      "parent": 42,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00A0\""
        },
        "id": {
          "type": "value",
          "value": "CardRehabWorklistUX-label-49"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 50,
      "name": "label",
      "parent": 43,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00A0\""
        },
        "id": {
          "type": "value",
          "value": "CardRehabWorklistUX-label-50"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "div",
      "parent": 37,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardRehabWorklistUX-div-51"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "div",
      "parent": 38,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabWorklistUX-div-52"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "Dropdown",
      "parent": 39,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardRehabWorklistUX-Dropdown-53"
        },
        "name": {
          "type": "value",
          "value": "encounter_type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.encounterTypeOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.encounter_type ?? \"\""
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "Dropdown",
      "parent": 40,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardRehabWorklistUX-Dropdown-54"
        },
        "name": {
          "type": "value",
          "value": "encounter_division"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.divisionOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.encounter_division?? \"\""
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "Dropdown",
      "parent": 41,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardRehabWorklistUX-Dropdown-55"
        },
        "name": {
          "type": "value",
          "value": "to_department_for_physiotherapist"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.divisionOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.to_department_for_physiotherapist ?? \"\""
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": null,
      "id": 56,
      "name": "div",
      "parent": 42,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardRehabWorklistUX-div-56"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 57,
      "name": "DateTextBox",
      "parent": 52,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabWorklistUX-DateTextBox-57"
        },
        "onChange": {
          "type": "code",
          "value": "(value: any)=>props.onChangeFilter?.(null,{name: \"order_time\", value})"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.order_time"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "Checkbox",
      "parent": 43,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filter?.include_complete ?? false"
        },
        "id": {
          "type": "value",
          "value": "CardRehabWorklistUX-Checkbox-58"
        },
        "label": {
          "type": "value",
          "value": "แสดงรายการที่สมบูรณ์",
          "valueEN": "Included Complete"
        },
        "name": {
          "type": "value",
          "value": "include_complete"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "FormField",
      "parent": 36,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabWorkListUX-FormField-59"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 60,
      "name": "label",
      "parent": 59,
      "props": {
        "children": {
          "type": "value",
          "value": "นักกายภาพบำบัด",
          "valueEN": "Physical Therapist"
        },
        "id": {
          "type": "value",
          "value": "CardRehabWorkListUX-label-60"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "div",
      "parent": 59,
      "props": {
        "children": {
          "type": "code",
          "value": "props.physiotherapistSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardRehabWorkListUX-div-61"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 61,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardRehabWorkListUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "cannotPay": false,
    "cashAmountText": "14",
    "citizenID": "31020000552",
    "language": "TH",
    "oweText": 123,
    "patientNameAndHN": "HN: xxxxx นายทดสอบ",
    "sumAmount": {
      "price": 100,
      "reimbursable": 42
    }
  },
  "width": 75
}

*********************************************************************************** */
